import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const jDogTrades: SeasonTrades[] = [
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.sagi,
        sentAway: "Kobe Bryant and David Lee",
        gotInReturn: "John Wall and Marc Gasol",
      },
    ],
  },
  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "George Hill",
        gotInReturn: "Arron Afflalo",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Roy Hibbert",
        gotInReturn: "Tristan Thompson",
      },
    ],
  },
];
